module.exports = __webpack_public_path__ + "img/SMP_profil-388224604-1400x900.e2a8e086.jpg";